<template>
  <div id="app">
    <SiteHeader />
    <main>
      <router-view />
    </main>
    <SiteFooter />
    
  </div>
</template>

<script>
import SiteHeader from '@/components/site-header/index.vue'
import SiteFooter from '@/components/SiteFooter.vue'
export default {
  components: { SiteHeader, SiteFooter },
  data() { return { qrVisible: false } },
  
}
</script>

<style>
main { min-height: 60vh }
/* 全局覆盖 Element 的弹窗层级 */
.v-modal {
  z-index: 1000 !important;
}

/* 提升自定义菜单层级 */
.mobile-drawer {
  z-index: 9999 !important;
}

</style>
